<section class="site-query-page">
  <header class="site-query-header">
    <h1 class="site-query-header-title">
      <span class="site-query-name">{{ 'siteQuery.title' | translate }}</span>
      <span class="site-query-title-separator">-</span>
      <span class="work-order-title">{{ workOrder?.title || '-' }}</span>
      <span class="work-order-number">{{ workOrder?.workOrderNumber }}</span>
    </h1>
  </header>

  <header class="page-heading list-actions">
    <button mat-flat-button color="primary" type="button" (click)="createSiteQuery()" [disabled]="!workOrder">
      <mat-icon>add</mat-icon>
      {{ 'siteQuery.list.create' | translate }}
    </button>
  </header>

  @if (loading) {
    <div class="loading-state" role="status">
      <mat-spinner diameter="36"></mat-spinner>
      <span>{{ 'siteQuery.loading' | translate }}</span>
    </div>
  } @else if (loadFailed) {
    <mat-card class="empty-state" appearance="outlined">
      <mat-icon>cloud_off</mat-icon>
      <h2>{{ 'siteQuery.list.loadErrorTitle' | translate }}</h2>
      <p>{{ 'siteQuery.list.loadError' | translate }}</p>
    </mat-card>
  } @else if (siteQueries.length === 0) {
    <mat-card class="empty-state" appearance="outlined">
      <mat-icon>help_outline</mat-icon>
      <h2>{{ 'siteQuery.list.emptyTitle' | translate }}</h2>
      <button mat-stroked-button color="primary" type="button" (click)="createSiteQuery()">
        <mat-icon>add</mat-icon>
        {{ 'siteQuery.list.createFirst' | translate }}
      </button>
    </mat-card>
  } @else {
    <div class="query-list" [attr.aria-label]="'siteQuery.list.ariaLabel' | translate">
      @for (siteQuery of siteQueries; track siteQuery.id) {
        <mat-expansion-panel class="query-card" [attr.data-status]="siteQuery.status">
          <mat-expansion-panel-header>
            <mat-panel-title class="query-summary">
              <span class="status-dot" aria-hidden="true"></span>
              <span class="query-identity">
                <strong class="query-number">{{
                  siteQuery.sqNumber || ('siteQuery.numberNotAssigned' | translate)
                }}</strong>
                <span class="revision">{{ 'siteQuery.revision' | translate }} {{ siteQuery.revision }}</span>
              </span>
              <span class="query-heading">
                <strong class="query-title">{{ siteQuery.title }}</strong>
                <span class="query-subtitle">
                  {{ 'siteQuery.fields.initiatedBy' | translate }} {{ siteQuery.initiatedBy }}
                  @if (siteQuery.discipline) {
                    · {{ siteQuery.discipline }}
                  }
                </span>
              </span>
              <strong class="query-status">{{ 'siteQuery.status.' + siteQuery.status | translate }}</strong>
              <span class="query-date">{{ siteQuery.queryDate || siteQuery.createdAt | date: 'dd.MM.yyyy' }}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="expanded-details">
            <h3>{{ 'siteQuery.fields.description' | translate }}</h3>
            <p>{{ siteQuery.description }}</p>
            <h3>{{ 'siteQuery.fields.suggestedSolution' | translate }}</h3>
            <p>{{ siteQuery.suggestedSolution || ('siteQuery.notProvided' | translate) }}</p>
            @if (siteQuery.selectedReferences.length > 0 || siteQuery.references) {
              <h3>{{ 'siteQuery.fields.references' | translate }}</h3>
              @if (siteQuery.selectedReferences.length > 0) {
                <ul>
                  @for (reference of siteQuery.selectedReferences; track reference.type + ':' + reference.id) {
                    <li>{{ 'siteQuery.referenceType.' + reference.type | translate }}: {{ reference.number }}</li>
                  }
                </ul>
              }
              @if (siteQuery.references) {
                <p>{{ siteQuery.references }}</p>
              }
            }
          </div>
          @if (siteQuery.attachments.length > 0) {
            <div class="query-attachments">
              <span class="attachment-count">
                <mat-icon>attach_file</mat-icon>
                {{ 'siteQuery.attachmentsCount' | translate: { count: siteQuery.attachments.length } }}
              </span>
              @for (attachment of siteQuery.attachments; track attachment.id) {
                <button
                  mat-button
                  type="button"
                  (click)="downloadAttachment(siteQuery, attachment.id, attachment.fileName)"
                >
                  {{ attachment.fileName }}
                </button>
              }
            </div>
          }
        </mat-expansion-panel>
      }
    </div>
  }
</section>
